export const uploadProfilePhoto = ({ accessToken, accountId }: NaTypes.Authenticate, photo: File): Promise<Response> => {
    if (!accessToken || !accountId) return Promise.reject(new Error('Missing access token or account ID'));

    const formData = new FormData();
    formData.append('accessToken', accessToken);
    formData.append('accountId', accountId);
    formData.append('uploaded_file', photo);

    return fetch(`${process.env.REACT_APP_API_URL}/api/v2/method/profile.uploadPhoto`, { method: 'POST', body: formData });
};